import { SVGProps } from 'react'

export const ShoppingBagIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="18"
    viewBox="0 0 15 18"
    fill="none"
  >
    <path
      d="M7.60156 0.25C9.53456 0.25 11.1016 1.817 11.1016 3.75H11.9766C13.4263 3.75 14.6016 4.92525 14.6016 6.375V14.25C14.6016 16.183 13.0346 17.75 11.1016 17.75H4.10156C2.16857 17.75 0.601562 16.183 0.601562 14.25V6.375C0.601562 4.92525 1.77682 3.75 3.22656 3.75H4.10156C4.10156 1.817 5.66857 0.25 7.60156 0.25ZM3.22656 5.5C2.74331 5.5 2.35156 5.89175 2.35156 6.375V14.25C2.35156 15.2165 3.13506 16 4.10156 16H11.1016C12.0681 16 12.8516 15.2165 12.8516 14.25V6.375C12.8516 5.89175 12.4598 5.5 11.9766 5.5H11.1016V7.25C11.1016 7.73325 10.7098 8.125 10.2266 8.125C9.74331 8.125 9.35156 7.73325 9.35156 7.25V5.5H5.85156V7.25C5.85156 7.73325 5.45981 8.125 4.97656 8.125C4.49331 8.125 4.10156 7.73325 4.10156 7.25V5.5H3.22656ZM7.60156 2C6.63506 2 5.85156 2.7835 5.85156 3.75H9.35156C9.35156 2.7835 8.56806 2 7.60156 2Z"
      fill="currentColor"
    />
  </svg>
)
